import { HashType } from "../Security/HashType";
import { IStreamReader } from "./IStreamReader";
/**
 * Rozhraní umožnující číst proud dat souboru a jeho další metadata
 */
export interface IFileStreamReader extends IStreamReader {
    /**
     * Název souboru
     */
    readonly name: string;

    /**
     * Vrátí hash celého souboru, pokud ho umí vypočítat, jinak null
     * @param hashType Algoritmus, který se má použít
     */
    getHash(hashType: HashType): Promise<string | null>;

    //TODO: další metadata
}
